import styled from 'styled-components';
import {MdArrowForwardIos} from 'react-icons/md';


export const Carousel = styled.div`
    display: flex;
    height: 50vh;
    width: 100%;
    background: #FF9746;
    align-self: center;
    justify-content: center;
    border-bottom: solid 1.2em #FCC089;
    border-top: solid 1.2em #FCC089;
    position: relative;
    `

export const PrimaveraOne = styled.img`
    position: absolute;
    z-index: 90;
    top: -20%; 
    right: -2px;
    width: 40%; 
    transform: scale(3) translateX(-80px);

    @media screen and (max-width: 1440px) {
        width: 30%;
        transform: scale(3) translateX(-50px);

    }   

    @media screen and (max-width: 768px) {
        width: 60%;
        transform: scale(3) translateX(-50px);
        right: -40px;
        top: -20%;
    }
`
    
    
export const WrapperCard = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    opacity: 1;

`

export const CarouselCard = styled.div`
    display: flex;
    flex: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    -webkit-box-shadow: 0px 0px 11px 3px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 0px 11px 3px rgba(0, 0, 0, 0.15);
    transition: 0.5s ease-in-out;
    pointer-events: none;
    opacity: 0;



    &.carousel_card_active {
        opacity: 1;
        pointer-events: visible;x
        background: black;
        
    }

`

export const ImgSlider = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;

`

export const Overlay = styled.div`
    display: flex;
    flex: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.29);
    padding: 40px 30px;
    align-items: flex-end;
    color: white;
    font-size: 26px;

`


export const ArrowRight = styled(MdArrowForwardIos)`
    margin-left: 3px;
    font-size: 2.2rem;
`
export const ArrowLeft = styled(MdArrowForwardIos)`
    font-size: 2.2rem;
    rotate: 180deg;
`


export const Button = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 50%;
    transform: translate(0, -50%);
    background-color: white;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    cursor: pointer;


    &.arrowRight {
        right: 30px;
    }

    &.arrowLeft {
        left: 30px;
    }
`




// -----------------------------------


export const ScrollDownButton = styled.button`
  position: absolute;
  left: 50%;
  bottom: -28px; /* ajuste conforme necessário para ficar sobre a linha */
  transform: translateX(-50%);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(255, 148, 60, 0.97);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(0,0,0,0.18);
  cursor: pointer;
  z-index: 3;
  padding: 0;
  outline: none;
  transition: transform .2s ease, box-shadow .2s ease;
  &:hover {
    transform: translateX(-50%) scale(1.04);
    transition: all 0.2s ease-in-out;
    transform: scale(1.1);
    box-shadow: 0 12px 26px rgba(0,0,0,0.22);
    
  }
`

export const ScrollArrow = styled.svg`
  width: 40px;
  height: 40px;
  margin-top: 10%;
  fill: #FFF;
  &:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.1);
    fill: #2E0011;
  }
  
`
  